@let memberDataValue = memberData();
@let adminAbilities = selectedAdminAbilities();

<rt-dialog-header [heading]="'tlc.members.invite_existing_members.heading' | translate" />

<rt-dialog-body variant="white">
  <form [formGroup]="formGroup" class="form-container">
    <div class="member-section">
      <div class="header-container">
        <div class="section-heading">
          <span class="heading">{{
            'tlc.members.invite_existing_members.member_section.heading' | translate
          }}</span>
          <span class="subheading">{{
            'tlc.members.invite_existing_members.member_section.subheading' | translate
          }}</span>
        </div>
        @if (displayShowAdvancedButton()) {
          <rt-button variant="plain" size="small" (click)="toggleAdvancedForm()">
            <span>{{ showAdvancedButtonText() }}</span>
            <rt-icon
              class="arrow-icon"
              name="keyboard-arrow-down"
              [class.advanced]="displayAdvancedForm()"
            />
          </rt-button>
        }
      </div>
      @if (memberDataValue) {
        <tlc-invite-existing-member-details-form
          [memberData]="memberDataValue"
          [parentForm]="formGroup"
          [displayAdvancedForm]="displayAdvancedForm()"
          (importCsvClick)="navigateToCsvImport()"
        />
      }
    </div>
    <div class="apps-and-access-section">
      <div class="access-roles">
        <div class="text">
          <span class="heading"> {{ 'tlc.members.add_member.roles.heading' | translate }}</span>
          <span [innerHTML]="'tlc.members.add_member.roles.subheading' | translate"></span>
          <div
            class="username-infobox-container"
            [class.open]="inviteMethodControl.value === InviteMethod.Login"
          >
            <rt-infobox
              class="username-infobox"
              type="information"
              iconName="info-outline"
              [isDismissible]="false"
            >
              <span>{{ 'tlc.members.add_member.username_infobox_text' | translate }}</span>
            </rt-infobox>
          </div>
        </div>

        <tlc-access-roles-table
          [recruiteeFormGroup]="seats.recruitee"
          [kiwiFormGroup]="seats.kiwi"
          [kiwiAdministratorRoleDisabled]="inviteMethodControl.value === InviteMethod.Login"
        />
      </div>
    </div>
    <div class="admin-permissions-section">
      @if (adminAbilities?.length === 0) {
        <div layout>
          <rt-button
            variant="plain"
            [disabled]="inviteMethodControl.value === InviteMethod.Login"
            (click)="openGiveAdminPermissionsDialog()"
          >
            <rt-icon prefix name="add" />
            <span>{{
              'tlc.members.invite_existing_members.admin_permissions_section.give_admin_permissions'
                | translate
            }}</span>
          </rt-button>
        </div>
      } @else {
        <div class="admin-permissions-container">
          <span class="heading">{{
            'tlc.members.invite_existing_members.admin_permissions_section.heading' | translate
          }}</span>
          <span class="subheading">{{
            'tlc.members.invite_existing_members.admin_permissions_section.subheading' | translate
          }}</span>
          <tlc-edit-member-permissions-box
            [abilities]="adminAbilities"
            [canManageTellent]="canManageTellent()"
            (actionClicked)="openGiveAdminPermissionsDialog()"
          />
        </div>
      }
    </div>
  </form>
</rt-dialog-body>

<rt-dialog-footer variant="white">
  <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button variant="primary" [loading]="loading$()" (click)="submit()"
    >{{ 'tlc.members.invite_existing_members.invite_member' | translate }}
  </rt-button>
</rt-dialog-footer>
